<!-- Trigger — rendered only when the toolbar container is narrow.
     Ordered before the content wrapper so it sits to the LEFT of any
     applied-filter chips that render alongside it in the sfb-filters
     region. -->
@if (collapsed()) {
  <button
    #triggerButton
    type="button"
    class="filter-group-trigger"
    [class.has-active]="activeCount() > 0"
    [class.is-open]="popoverOpen()"
    [attr.aria-haspopup]="'dialog'"
    [attr.aria-expanded]="popoverOpen()"
    [attr.aria-label]="triggerAriaLabel()"
    (click)="toggleTrigger($event)"
  >
    <mat-icon class="filter-group-trigger-icon">tune</mat-icon>
    <span class="filter-group-trigger-label">{{ label() }}</span>
    @if (activeCount() > 0) {
      <span class="filter-group-count" aria-hidden="true">{{ activeCount() }}</span>
    }
    <mat-icon
      class="filter-group-trigger-chevron"
      [class.rotated]="popoverOpen()"
      aria-hidden="true"
      >expand_more</mat-icon
    >
  </button>
}

<!-- Content wrapper — ALWAYS mounted. Uses `display: contents` in the
     inline case so projected `<app-select>`s stay direct flex siblings
     of the toolbar; hidden when collapsed and the popover is closed.
     `DomPortal` teleports this element into the overlay when the
     trigger opens and returns it home on close. -->
<div
  #filterContent
  class="filter-group-content"
  [class.is-hidden]="collapsed() && !popoverOpen()"
  [attr.role]="collapsed() && popoverOpen() ? 'dialog' : null"
  [attr.aria-modal]="collapsed() && popoverOpen() ? 'true' : null"
  [attr.aria-label]="collapsed() && popoverOpen() ? dialogAriaLabel() : null"
>
  <ng-content></ng-content>
</div>
